<template>
	<div class="center-container">
		<h1>Reset your password</h1>
		<p>Enter your new password.</p> 
		
		<form @submit.prevent="onSend">
			<div class="login-container-alt">
				<label for="password">New Password</label>
				<input type="password" name="password" v-model="password" id="reset-password" required>
				<label class="password-toggle-container">Show/Hide Password
					<input v-on:click="togglePassword" type="checkbox">
					<span class="checkmark"></span>
				</label>
				<button id="send-btn" type="submit">Set</button>
			</div>
		</form>
		
		<br>
		<p :style="{ opacity: 0.5 }">***<br>Contact us at <a href="mailto:support@bookplate.co">support@bookplate.co</a>, anytime.</p>
	</div>
</template>
<script>
	export default 
	{
		created () 
		{
			document.title = "Support | Bookplate";
			try
			{
				var login = document.getElementById("login-widget");
				login.className = "";
			}
			catch(e)
			{ 
				//pass
			}
		},
		computed:
		{
			key: function()
			{
				return this.$route.params.id;
			}
		},
		methods:
		{
			togglePassword: function ()
			{
				var input = document.getElementById("reset-password");
				if (input.type === "password") 
				{
					input.type = "text";
				} 
				else 
				{
					input.type = "password";
				}
			},
			async onSend()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				let vue = this;

				document.getElementById("send-btn").innerHTML = "Set";
				document.getElementById("send-btn").className = "disabled";
				
				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					body: JSON.stringify({
						"password": this.password
					}),
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/forgot-password/" + this.key, data)
				.then(function(response)
				{
					if(response.status == 401)
					{
						vue.$alert("Sorry, the link you are using has expired. Send another reset link or contact support@bookplate.co if this problem persists.", "Link expired");
						vue.$router.push('/forgot-password');
					}
					else
					{
						vue.$router.push('/login');
					}
				})
			}
		}
	}
</script>